import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import commonStyles from '../../ConfirmPopup.module.scss';
import styles from './CompletedRegistrationBlock.module.scss';
import { CompletedRegistrationBlockProps } from '../../types';
import { TEXTS } from '../../constants';

function CompletedRegistrationBlock({
  isCourseRegistrationCompleted,
  isAfterWeb,
}: CompletedRegistrationBlockProps) {
  const nodeRef = useRef<HTMLDivElement | null>(null);

  return (
    <CSSTransition
      in={isCourseRegistrationCompleted}
      nodeRef={nodeRef}
      timeout={300}
      classNames={{
        enter: commonStyles.popupBackground_enter,
        enterActive: commonStyles.popupBackground_enterActive,
        exitActive: commonStyles.popupBackground_exitActive,
        exit: commonStyles.popupBackground_exit,
      }}
      unmountOnExit
    >
      <div className={styles.container} ref={nodeRef}>
        <div className={styles.grishaWrapper}>
          <div className={styles.grisha} />
          <div className={styles.grisha_title}>
            {TEXTS[isAfterWeb ? 'AFTER_BUY_COMPLETED' : 'COMPLETED'].TITLE}
          </div>

          <div className={styles.grisha_text}>
            {TEXTS[isAfterWeb ? 'AFTER_BUY_COMPLETED' : 'COMPLETED'].TEXT}
          </div>
        </div>
      </div>
    </CSSTransition>
  );
}

export { CompletedRegistrationBlock };
